import React, { Component } from 'react';
import '../css/components/Paso.css';
import BeneficioInicio from './BeneficioInicio';

class Paso extends Component {
  render() {
    return (
      <div className="paso__div-general">
        <div className="paso__div-principal">
          <div className="paso__div-Titulo">{this.props.titulo}</div>
          {this.props.nombre && <div className="paso__div-nombre">{this.props.nombre}</div>}
          {this.props.paso && <div className="paso__div-paso">{this.props.paso}</div>}
        </div>
        {this.props.textoBeneficio && <BeneficioInicio textoBeneficio={this.props.textoBeneficio}></BeneficioInicio>}
        {this.props.descripcion && <div className="paso__div-descripcion">{this.props.descripcion}</div>}
      </div>
    );
  }
}

export default Paso;



// WEBPACK FOOTER //
// ./src/components/Paso.js